import { FC } from 'react';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { getIsSseConnected, getSseLog } from '../../store/sseSlice';
import { icons } from '../../icons/IconSet';
import TooltipWrapper from '../common/TooltipWrapper';
import DropDown from '../dropdown/DropDown';

export interface ISseMsgLog {
  msg: string,
  repeates: number,
}

const SseWidget: FC = () => {
  const sseLog = useTypedSelector(getSseLog());
  const isSseConnected = useTypedSelector(getIsSseConnected());  

  const turnStrLogIntoSseMsgLog = (log: string[]): ISseMsgLog[] => log
    .reduce((acc, msg) => {
      acc[acc?.length - 1]?.msg === msg
        ? (acc[acc.length - 1].repeates = acc[acc.length - 1].repeates + 1)
        : (acc = [...acc, { msg, repeates: 1 }]);
      return acc;
    }, [] as ISseMsgLog[]);

  return (
    <DropDown
      noOutline 
      direction = 'left'
      className="min-w-[400px]"
      btn={
        <TooltipWrapper content={isSseConnected
          ? 'SSE is connected'
          : 'SSE is NOT connected'
        }>
          <div className={`
            flex items-center gap-1 border-[0px] px-2 py-1 rounded-xl
            ${isSseConnected
              ? 'text-green-700 border-green-500'
              : 'text-red-700 border-red-500'
            }
          `}>
            <div className="">
              {
                isSseConnected
                  ? icons('wifi', { stroke: 'green', width: '1.2em' })
                  : icons('wifi-off', { stroke: 'red' })
              }
            </div>
            <div className=" text-[.8em]">
              {sseLog.length}
            </div>
          </div>
        </TooltipWrapper>
      }
    >
      <div className="flex flex-col gap-1 max-h-[15em] text-sm overflow-y-auto stylledScroll">
        {turnStrLogIntoSseMsgLog(sseLog).map(({ msg, repeates }, indx) => (
          <div key={`sse-msg-${indx}`} className="">
            {msg}{repeates > 1 ? <> × {repeates}</> : ''}
          </div>
        ))}
      </div>
      
    </DropDown>
  );

}

export default SseWidget;
